export const itemNameMaxLength = 60;
